import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ed87ce2a")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock(_component_el_form_item, {
    prop: _ctx.name,
    rules: _ctx.rules
  }, {
    default: _withId(() => [
      _createVNode(_component_el_checkbox, {
        modelValue: _ctx.inputValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputValue = $event)),
        name: _ctx.name,
        value: _ctx.value,
        onChange: _ctx.updateValue
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.displayMessage), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "name", "value", "onChange"])
    ]),
    _: 1
  }, 8, ["prop", "rules"]))
})